import React, { useState } from "react";
import { CreditCard, Loader2 } from "lucide-react";
import { stripePortal } from "@/api/launch";

function isHttpsUrl(u: string | null | undefined): boolean {
  if (!u) return false;
  try { return new URL(u).protocol === "https:"; } catch { return false; }
}

export function hasManageableSubscription(me: { paid_subscription?: unknown } | null | undefined): boolean {
  const ps = me?.paid_subscription;
  if (ps == null || ps === false) return false;
  if (typeof ps === "object" && "status" in (ps as object)) {
    return ["active", "trialing", "past_due"].includes(String((ps as { status?: unknown }).status).toLowerCase());
  }
  return true;
}

export function ManageSubscriptionButton({ lang }: { lang: "tr" | "en" }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  async function open() {
    if (busy) return;
    setBusy(true);
    setFailed(false);
    try {
      const url = await stripePortal();
      if (isHttpsUrl(url)) { window.location.href = url; return; }
      setFailed(true);
    } catch {
      setFailed(true);
    }
    setBusy(false);
  }

  return (
    <div>
      <button onClick={open} disabled={busy} data-testid="account-manage-subscription"
        className="flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-atlas-500 to-atlas-600 px-4 py-3 text-sm font-bold text-atlas-ink transition hover:shadow-glow disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />}
        {busy ? (lang === "tr" ? "Stripe açılıyor..." : "Opening Stripe...") : (lang === "tr" ? "Aboneliği Yönet" : "Manage Subscription")}
      </button>
      {failed && (
        <p className="mt-2 text-xs text-gold-300" data-testid="account-portal-error">
          {lang === "tr" ? "Abonelik yönetim ekranı şu anda kullanılamıyor." : "The subscription management screen is unavailable right now."}
        </p>
      )}
    </div>
  );
}
